import { render, staticRenderFns } from "./EntradaItensEditModal.vue?vue&type=template&id=63e3a2a2&scoped=true"
import script from "./EntradaItensEditModal.vue?vue&type=script&lang=js"
export * from "./EntradaItensEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e3a2a2",
  null
  
)

export default component.exports